import { useMediaQuery, useTheme } from '@material-ui/core'
import { Cancel } from '@material-ui/icons'
import React from 'react'
import {
  Create,
  CreateProps,
  ListButton,
  required,
  SaveButton,
  SelectInput,
  SimpleForm,
  TextInput,
  Toolbar,
  ToolbarProps,
  useTranslate,
} from 'react-admin'
import { NotificationConditionalContentDto } from '../../../core/dto/system-notifications/notification-conditional-content.dto'
import { jsonStatusPropertyComparisonTypes } from '../../../core/enum/jsonStatusPropertyComparisonTypes'
import FilteredReferenceInput from '../../common/FilteredReferenceInput'
import { ResourceName } from '../../../core/ResourceName'
import { NotificationCategoryDto } from '../../../core/dto/system-notifications/notification-category.dto'

const validateNotificationConditionalContentCreate = (
  values: NotificationConditionalContentDto,
) => {
  const errors: { [n: string]: string } = {}
  if (!values.description) {
    errors.description = 'ra.validation.required'
  }
  if (!values.jsonStatusPropertyPath) {
    errors.jsonStatusPropertyPath = 'ra.validation.required'
  }
  if (!values.jsonStatusPropertyComparisonType) {
    errors.jsonStatusPropertyComparisonType = 'ra.validation.required'
  }
  if (!values.comparisonValue) {
    errors.comparisonValue = 'ra.validation.required'
  }
  if (!values.notificationCategoryId) {
    errors.notificationCategoryId = 'ra.validation.required'
  }
  return errors
}

const CreateTitle = () => {
  const translate = useTranslate()
  return (
    <span>
      {translate('resources.notification-conditional-contents.titles.create')}
    </span>
  )
}

const CreateToolbar = (props: ToolbarProps) => (
  <Toolbar {...props}>
    <SaveButton />
    <ListButton icon={<Cancel />} label="const.cancel" />
  </Toolbar>
)

export const NotificationConditionalContentCreate = (props: CreateProps) => {
  const theme = useTheme()
  const translate = useTranslate()
  const smallScreen = useMediaQuery(theme.breakpoints.down('sm'))

  return (
    <Create {...props} title={<CreateTitle />}>
      <SimpleForm
        redirect="show"
        validate={validateNotificationConditionalContentCreate}
        toolbar={<CreateToolbar />}
      >
        <TextInput source="description" isRequired />
        <TextInput source="jsonStatusPropertyPath" isRequired />
        <SelectInput
          source="jsonStatusPropertyComparisonType"
          choices={Object.keys(jsonStatusPropertyComparisonTypes).map(
            (key: string) => ({
              id: key,
              name: translate(
                `resources.enums.jsonStatusPropertyComparisonTypes.${key}`,
              ),
            }),
          )}
          validate={required()}
        />
        <TextInput source="comparisonValue" isRequired />
        <FilteredReferenceInput
          source="notificationCategoryId"
          defaultValue={null}
          reference={ResourceName.NOTIFICATION_CATEGORIES}
          sort={{ field: 'id', order: 'ASC' }}
          perPage={smallScreen ? 5 : 15}
          filterSource="search"
          selectWithPaginationInputProps={{
            optionText: (choice: NotificationCategoryDto) =>
              `${choice.defaultTitle}`,
            showFilter: true,
          }}
        />
      </SimpleForm>
    </Create>
  )
}
